export default (value) => {
    return value.message
}